/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigGradingCategoryId } from './taskEvaluationConfigGradingCategoryId';
import type { TaskEvaluationConfigGradingRelevant } from './taskEvaluationConfigGradingRelevant';
import type { TaskEvaluationConfigFormalCriteriaSource } from './taskEvaluationConfigFormalCriteriaSource';
import type { TaskEvaluationConfigFormalCriteria } from './taskEvaluationConfigFormalCriteria';
import type { TaskEvaluationConfigCompletionPolicyOverride } from './taskEvaluationConfigCompletionPolicyOverride';
import type { TaskEvaluationConfigCompletionMinLevelsOverride } from './taskEvaluationConfigCompletionMinLevelsOverride';
import type { TaskEvaluationConfigAttachmentPolicy } from './taskEvaluationConfigAttachmentPolicy';
import type { TaskEvaluationConfigCompletionPolicyEffective } from './taskEvaluationConfigCompletionPolicyEffective';
import type { TaskEvaluationConfigCompletionMinLevelsEffective } from './taskEvaluationConfigCompletionMinLevelsEffective';

/**
 * Configuration for the evaluation of a task
 */
export interface TaskEvaluationConfig {
  mode?: string;
  gradingCategoryId?: TaskEvaluationConfigGradingCategoryId;
  gradingRelevant?: TaskEvaluationConfigGradingRelevant;
  formalCriteriaSource?: TaskEvaluationConfigFormalCriteriaSource;
  formalCriteria?: TaskEvaluationConfigFormalCriteria;
  completionPolicyOverride?: TaskEvaluationConfigCompletionPolicyOverride;
  completionMinLevelsOverride?: TaskEvaluationConfigCompletionMinLevelsOverride;
  attachmentPolicy?: TaskEvaluationConfigAttachmentPolicy;
  completionPolicyEffective?: TaskEvaluationConfigCompletionPolicyEffective;
  completionMinLevelsEffective?: TaskEvaluationConfigCompletionMinLevelsEffective;
}
